var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegionPin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 39,
    viewBox: "0 0 31 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6971 36.5076L15.177 37L15.6568 36.5076L25.8048 26.0933C31.3984 20.3528 31.3984 11.0458 25.8048 5.30532C20.2112 -0.435108 11.1422 -0.435105 5.54854 5.30532L5.29869 5.56173C-0.4329 11.4437 -0.432895 20.9805 5.29869 26.8625L14.6971 36.5076Z",
    fill: "#F9C700",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1178 16.2615C22.1178 12.4303 19.0679 9.32446 15.3055 9.32446C11.5432 9.32446 8.49316 12.4303 8.49316 16.2615C8.49316 20.0928 11.5432 23.1986 15.3055 23.1986C19.0679 23.1986 22.1178 20.0928 22.1178 16.2615Z",
    fill: "#2A467B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegionPin);
export default __webpack_public_path__ + "static/media/region-pin.d4b786761ebe2fd64057df7a4710c071.svg";
export { ForwardRef as ReactComponent };